import { z } from "zod";
//#region src/const/oauth2Client.ts
const OAuth2ClientType = {
	web: "web",
	mobileIos: "mobile-ios",
	mobileAndroid: "mobile-android"
};
const OAuth2ClientTypeEnum = z.enum(Object.values(OAuth2ClientType));
//#endregion
export { OAuth2ClientType, OAuth2ClientTypeEnum };
